import React from 'react';
import { useCartContext } from '../Context/CartContext';

import { Button, Row, Col, Container } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import '../ItemCart/Itemcart.css';

const ItemCart = () => {
  const { cart, removeProduct, totalPrice } = useCartContext();

  const handleRemove = (item) => {
    toast.error('Producto eliminado del carrito');
    removeProduct(item.id, item.selectedSize, item.acomp, item.selectedDrink, item.selectedDip);
  };

  const getFirstImage = (image) => {
    try {
      if (Array.isArray(image)) return image[0];
      if (typeof image === 'string') {
        const parsed = JSON.parse(image);
        if (Array.isArray(parsed)) return parsed[0];
        return image;
      }
    } catch {
      return image;
    }
  };

  return (
    <Container fluid className='p-3'>
      <Toaster />
      <h3 className="mb-4 text-center">🛍️ Productos en el Carrito</h3>

      {cart.length === 0 ? (
        <p className="text-center">No hay productos en el carrito.</p>
      ) : (
        cart.map((item, idx) => {
          const drinkPrice = item.selectedDrink?.precio || 0;
          const subtotal = item.quantity * (item.precio + drinkPrice);
          const imagen = getFirstImage(item.image);

          return (
            <div key={idx} className="mb-3 p-3 border rounded bg-light">
              <Row className="align-items-center">
                <Col xs={12} sm={3} className="text-center mb-2 mb-sm-0">
                  <img
                    src={imagen}
                    alt={item.name}
                    className="img-fluid rounded"
                    style={{ maxHeight: '80px', objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <p><strong>{item.name}</strong></p>
                  <p><b>Unidades:</b> {item.quantity}</p>
                  <p><b>Subtotal:</b> ${subtotal}</p>
                  <p><b>Anotaciones:</b> {item.anotaciones || 'Ninguna'}</p>
                </Col>
                <Col xs={12} sm={3} className="text-end">
                  <Button variant="danger" size="sm" onClick={() => handleRemove(item)}>
                  <i class="bi bi-trash"></i>                  </Button>
                </Col>
              </Row>
            </div>
          );
        })
      )}

    </Container>
  );
};

export default ItemCart;
